import {
  Backdrop, Box, Button, CircularProgress, Container, FormControl,
  Grid, InputLabel, MenuItem, Select, TextField, Typography
} from "@mui/material";
import axios, { AxiosInstance } from "axios";
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActions } from "@mui/material";
import Cookies from "universal-cookie";
import { urlApi } from "../../parametrage/Pays/RowPays";
import CheckAttr from "../../../../utils/CheckAttr";
import { AlertType } from "../../../../types/AlertType";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { downloadFile } from "../../../../utils/utils";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loggoutUser } from "../../../../redux/actions/logginUser";

type EXTRACTION_TYPE = "CUMUL_PERIODE" | "CUMUL_PAR_MOIS";

interface SocieteFacturation {
  id: number;
  libelle: string;
}

interface InputValidation {
  dateDebut: boolean;
  dateFin: boolean;
}

const resetInpuValidation: InputValidation = {
  dateDebut: false,
  dateFin: false,
};

const extractionTypeDatas = [
  {
    libelle: "Cumul période",
    value: "CUMUL_PERIODE",
  },
  {
    libelle: "Mois par mois",
    value: "CUMUL_PAR_MOIS",
  }
];

const Rentabilite = () => {
  const [dateDebut, setDateDebut] = useState<string>();
  const [dateFin, setDateFin] = useState<string>();
  const [extractionType, setExtractionType] = useState<EXTRACTION_TYPE>('CUMUL_PERIODE');

  // Société de facturation (filtre optionnel)
  const [societes, setSocietes] = useState<SocieteFacturation[]>([]);
  const [societe, setSociete] = useState<string>("");

  // Error
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [errorInput, setErrorInput] = useState<InputValidation>(resetInpuValidation);

  // Axios
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  // Autres
  const [loader, setLoader] = useState<boolean>(false);

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();


  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  // Récupère la liste des sociétés de facturation pour le filtre
  useEffect(() => {
    http.get("societe-facturation/find/all")
      .then((res) => {
        Array.isArray(res.data) && setSocietes(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    // Verificaton si les champ date debut et date fin sont rempli
    if (!CheckAttr(dateDebut) || !CheckAttr(dateFin)) {
      if (!CheckAttr(dateDebut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateDebut: true,
        }));
      }

      if (!CheckAttr(dateFin)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateFin: true,
        }));
      }

      setAlerteMessage("Merci de remplir les champs en rouge SVP!");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }

    // Verification si date fin est supérieur au date debut
    const date_debut = new Date(dateDebut as string);
    const date_fin = new Date(dateFin as string);

    if (date_debut.getTime() > date_fin.getTime()) {
      setErrorInput((prev: InputValidation) => ({
        ...prev,
        dateDebut: true,
      }));

      setErrorInput((prev: InputValidation) => ({
        ...prev,
        dateFin: true,
      }));

      setAlerteMessage("Désolé! La date fin doit être supèrieur ou égal à la date debut !");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }

    return true;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "date_debut") {
      setDateDebut(value);

      if (CheckAttr(value) && CheckAttr(dateFin)) {
        const subStrDateDebut = value?.slice(0, -3);
        const subStrDateFin = dateFin?.slice(0, -3);

        if (subStrDateDebut === subStrDateFin) {
          setExtractionType('CUMUL_PERIODE');
        } else {
          setExtractionType('CUMUL_PAR_MOIS');
        }
      }
    }

    if (name === "date_fin") {
      setDateFin(value);

      if (CheckAttr(dateDebut) && CheckAttr(value)) {
        const subStrDateDebut = dateDebut?.slice(0, -3);
        const subStrDateFin = value?.slice(0, -3);

        if (subStrDateDebut === subStrDateFin) {
          setExtractionType('CUMUL_PERIODE');
        } else {
          setExtractionType('CUMUL_PAR_MOIS');
        }
      }
    }
  };

  const handleExtract = () => {
    if (isValidate()) {
      const data = {
        date_debut: dateDebut,
        date_fin: dateFin,
        societe: societe,
      };
      setLoader(true);

      if (extractionType === 'CUMUL_PERIODE') {
        http.post('extraction/rentabilite/by-period', data)
          .then((res) => {
            setAlerteMessage("Extraction Achever");
            setAlertType("success");
            setOpenSnack(true);
            downloadFile(res.data as string);
          })
          .catch((error) => {
            console.log(error);
            setAlertType("error");
            setOpenSnack(true);
          })
          .finally(() => {
            setLoader(false);
          });
      } else {
        http.post('extraction/rentabilite/month-by-month', data)
          .then((res) => {
            setAlerteMessage("Extraction Achever");
            setAlertType("success");
            setOpenSnack(true);
            downloadFile(res.data as string);
          })
          .catch((error) => {
            console.log(error);
            setAlertType("error");
            setOpenSnack(true);
          })
          .finally(() => {
            setLoader(false);
          });
      }
    }
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 10 }}>
        <Card sx={{ maxWidth: 845 }}>
          <CardMedia
            component="img"
            image="/images/extraction_rentabilite.png"
            alt="green iguana"
            sx={{ display: { xs: 'none', sm: 'flex' }, height: 140 }}
          />

          <CardContent>
            <Typography gutterBottom variant="h5" component="div" mb={4}>
              Periode
            </Typography>
            <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
              <Grid item xs={6} sm={6} md={6}>
                <TextField
                  name="date_debut"
                  label="Date debut"
                  type="date"
                  color="warning"
                  fullWidth
                  error={errorInput.dateDebut}
                  value={dateDebut}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <TextField
                  name="date_fin"
                  label="Date fin"
                  type="date"
                  color="warning"
                  fullWidth
                  error={errorInput.dateFin}
                  value={dateFin}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl
                  variant="outlined"
                  sx={{ marginTop: 5 }}
                  fullWidth
                >
                  <InputLabel
                    htmlFor="type"
                    color="warning"
                  >
                    Type Cumule
                  </InputLabel>
                  <Select
                    id="type"
                    native
                    color="warning"
                    value={extractionType}
                    onChange={(e) => setExtractionType(e.target.value as EXTRACTION_TYPE)}
                    label="Type Cumule"
                    inputProps={{
                      name: "type",
                    }}
                  >
                    {extractionTypeDatas.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <FormControl
                  variant="outlined"
                  sx={{ marginTop: 5 }}
                  fullWidth
                >
                  <InputLabel
                    id="societe"
                    color="warning"
                  >
                    Société de facturation
                  </InputLabel>
                  <Select
                    labelId="societe"
                    id="societe-select"
                    name="societe"
                    color="warning"
                    value={societe}
                    onChange={(e) => setSociete(e.target.value as string)}
                    label="Société de facturation"
                  >
                    <MenuItem value="">
                      <em>Toutes</em>
                    </MenuItem>
                    {societes.map((item) => (
                      <MenuItem key={item.id} value={item.id.toString()}>
                        {item.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>

          <CardActions sx={{ pb: 3 }}>
            <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color="warning"
                    size="large"
                    sx={{ textTransform: 'none' }}
                    endIcon={<FileDownloadIcon />}
                    onClick={() => handleExtract()}
                  >
                    Extraire
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Container>

      {stackAlert}
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default Rentabilite;
